class upsellProduct extends HTMLElement {
    constructor() {
      super();
      this.bindEvents();

    }
    bindEvents() {
        this.querySelectorAll('upsell-product .price_box_img').forEach((item) =>{        
        // console.log(item); 
        item.addEventListener('click', this.onSummaryClick.bind(this))
        });
    }
    onSummaryClick(event,selectItemPrice) {       
        // button_total_price
        const element = event.currentTarget; 
        var element_price =  parseInt(element.getAttribute("upsell-product-price"));      
        var element_product_id =  element.getAttribute("upsell-product-id"); 
        var element_upsell_var_id =  element.getAttribute("upsell-var-id"); 
        var element_upsell_product_title =  element.getAttribute("upsell-product-title");

        var element_upsell_item_qty =   parseInt(element.parentNode.querySelector('.quantity__input').value);
        var totalt_product_and_upsell_product_price = parseInt(document.querySelector("#button_total_price").innerHTML); 
        // console.log('totalt_product_and_upsell_product_price = '+totalt_product_and_upsell_product_price);
        // console.log(`element_upsell_var_id = ${element_upsell_var_id}, element_product_id = ${element_product_id}--${element_upsell_product_title},element_upsell_item_qty = ${element_upsell_item_qty} `);
        var Bundle_ID = document.querySelector('#bundle_properties_wrap').getAttribute('now');
        const detailsElement = element.parentNode;
        if(detailsElement.classList.contains('active')){
            var selectItemPrice =  parseInt(document.querySelector("input#temp_price").value); 
            detailsElement.classList.remove('active')
            selectItemPrice = selectItemPrice - element_price;          
            // console.log('selectItemPrice if = '+selectItemPrice);
            document.querySelector('#main_product_bundle_id').setAttribute('disabled','disabled');
            document.querySelector("input#temp_price").value = selectItemPrice;
            var final_product_upsell_price =  Shopify.formatMoney(totalt_product_and_upsell_product_price + selectItemPrice, Shopify.money_format);
            // console.log('final_product_upsell_price if= '+final_product_upsell_price)
            document.querySelector('.button-total-price').innerHTML = final_product_upsell_price;
            document.querySelector('.button-total-price').setAttribute('product-price',final_product_upsell_price);
            document.querySelector(`#upsell_var_ids [value="${element_upsell_var_id}"]`).remove();
            document.querySelector(`#upsell_var_ids .qty_${element_upsell_var_id}`).remove();
            document.querySelector(`#upsell_var_ids .properties_${element_upsell_var_id}`).remove();
        //    Bundle_ID = `${Date.now()}`;
        }else{        
            var selectItemPrice =  parseInt(document.querySelector("input#temp_price").value);   
            detailsElement.classList.add('active')
            selectItemPrice = selectItemPrice + element_price;
            document.querySelector("input#temp_price").value = selectItemPrice ;
            // console.log('selectItemPrice else = '+selectItemPrice);     
            document.querySelector('#main_product_bundle_id').removeAttribute('disabled');       
            // Shopify.formatMoney(2000, Shopify.money_format) 
            var final_product_upsell_price = Shopify.formatMoney(totalt_product_and_upsell_product_price + selectItemPrice, Shopify.money_format);
            // console.log('final_product_upsell_price = '+final_product_upsell_price);
            document.querySelector('.button-total-price').innerHTML = final_product_upsell_price;
            document.querySelector('.button-total-price').setAttribute('product-price',final_product_upsell_price);
            document.querySelector('#upsell_var_ids').innerHTML += `<input type="hidden" name="items[][id]" value="${element_upsell_var_id}" class="product-upsell-id">`;
            document.querySelector('#upsell_var_ids').innerHTML += `<input type="hidden" name="items[][quantity]" value="${element_upsell_item_qty}" class="product-upsell-id qty_${element_upsell_var_id}">`;
        //    Bundle_ID = `${Date.now()}`;
            document.querySelector('#upsell_var_ids').innerHTML += `<input type="hidden" name="items[][properties][_Bundle_ID]" value="${Bundle_ID}" class="product-upsell-id properties_${element_upsell_var_id}">`;
        }        
        // document.querySelector('#bundle_properties_wrap').innerHTML = `<input type="hidden" name="properties[Main_bundle_ID]" value="${Bundle_ID}" class="product-upsell-id main_properties_${element_upsell_var_id}">`;
    }  
}

customElements.define('upsell-product', upsellProduct);


// input variant: name="items[][id]"
// input quantity: name="items[][quantity]"
// input property: name="items[][properties][property_label]"


class upsellQtyInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
      this.input.addEventListener('change', this.onInputChange.bind(this));
      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );     
    }
    onInputChange(event) {
        this.validateQtyRules();
    }
    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
    validateQtyRules() {
        // console.log(this.parentNode.previousElementSibling.previousElementSibling);
        const value = parseInt(this.input.value);  
        var variant_id = this.getAttribute('data-variantid');
       
        // document.querySelector(`.qty_${variant_id}`).value = value;
        document.querySelectorAll(`.qty_${variant_id}`).forEach(el => {
            el.value = value;
        });
        console.log(document.querySelectorAll(`.qty_${variant_id}`));
        // this.parentNode.previousElementSibling.previousElementSibling.setAttribute('data-upsell-item-qty',value);        
        if (this.input.min) {
            const min = parseInt(this.input.min);
            const buttonMinus = this.querySelector(".quantity__button[name='minus']");
            buttonMinus.classList.toggle('disabled', value <= min);
            // console.log('min-value = '+value); 
        }
        if (this.input.max) {
            const max = parseInt(this.input.max);
            const buttonPlus = this.querySelector(".quantity__button[name='plus']");
            buttonPlus.classList.toggle('disabled', value >= max);
            // console.log('max-value = '+value); 
        }
    }
}
customElements.define('upsell-qty-input', upsellQtyInput);